<div class="d-flex flex-column gap-20 w-100 flex-grow-1">
  <div class="d-flex flex-column align-items-center gap-4">
    <h1 class="fs-24 fw-bold mb-0 text-center" [innerHTML]="offer.title"></h1>
    @if (offer.subtitle) {
      <div class="fs-16 fw-normal" [innerHTML]="offer.subtitle"></div>
    }
  </div>

  <!-- Offer Content -->
  <div class="d-flex flex-column gap-20 w-100 flex-grow-1 align-items-center">
    @if (offer.imageClass) {
      <div class="w-100 upsell-image" [ngClass]="offer.imageClass" [ngStyle]="offer.imageStyle"></div>
    }

    <div class="fs-16 fw-light w-100" [innerHTML]="offer.description"></div>

    <div class="fs-14 fw-light w-100 text-center muted-color" i18n="@@specialOfferFirstTime">
      Special offer only for first time subscribers
    </div>

    <div class="product d-flex justify-content-space-between w-100">
      <div class="d-flex flex-column justify-content-space-between align-items-start">
        <div class="product-title" i18n="@@subscribersOnlyPrice">Subscribers only price</div>
        <div class="price-container fs-14">
          <span class="full-price">{{ offer.fullPriceLabel }}</span>
          <span class="fw-normal muted-color" i18n="@@oneTimePayment"> one time payment</span>
        </div>
      </div>
      <div class="d-flex flex-column align-items-center justify-content-center flex-shrink-0">
        <div class="product-price">
          {{ offer.priceLabel }}
        </div>
      </div>
      <div
        class="product-badge fs-12 fw-bold"
        [ngClass]="{
          orange: offer.colorScheme === 'orange',
          blue: offer.colorScheme === 'blue',
        }"
      >
        <ng-container i18n="@@upsellSaveToday">SAVE {{ offer.discountLabel }} TODAY</ng-container>
      </div>
    </div>

    <div class="d-flex flex-column gap-8 w-100 align-items-center">
      @if (isPurchasing) {
        <mat-spinner diameter="40"></mat-spinner>
      }

      @if (!isPurchasing) {
        <button
          mat-flat-button
          class="tagus w-100 d-flex align-items-center justify-content-center gap-8"
          (click)="onContinue()"
        >
          {{ offer.cta }}
        </button>
      }

      @if (!isPurchasing) {
        <button mat-button class="w-100 skip-button" (click)="onSkip()" i18n="@@skipForNow">
          Skip for now
        </button>
      }

      <!-- Disclaimer -->
      <div class="fs-12 fw-light muted-color text-center mt-8" i18n="@@chargeDisclaimer">
        On click your account will be charged immediately for the add on service you select
      </div>
    </div>
  </div>
</div>
